import env from '@/env';
import { Environment } from '@/types/environment';
import parseLocalStorage from '@/utils/localStorage';
import {
  ENV_CONFIGS,
  QUALTRICS_KEY_GENERAL_SURVEY,
  QUALTRICS_KEY_LOCALSTORAGE,
  QUALTRICS_KEY_METADATA,
  QUALTRICS_SCRIPT_ID,
} from './constants';
import { QualtricsData } from './types';

const getExternalReferenceScript = (userId: string): string => `
  window.QSI = window.QSI || {};
  window.QSI.config = {
    externalReference: ${userId}
  };
`;

export const initializeQualtrics = (userId: string): void => {
  if (!document.body || document.getElementById(QUALTRICS_SCRIPT_ID)) {
    return;
  }

  const { qualtricsSnippetPath, qualtricsSnippetId, isEnabled } = ENV_CONFIGS[env.VITE_NODE_ENV as Environment];
  if (qualtricsSnippetPath && qualtricsSnippetId && isEnabled) {
    const scriptTag = document.createElement('script');
    scriptTag.id = QUALTRICS_SCRIPT_ID;
    scriptTag.innerHTML = getExternalReferenceScript(userId);

    const snippetScriptTag = document.createElement('script');
    snippetScriptTag.src = qualtricsSnippetPath;

    const snippetIdTag = document.createElement('div');
    snippetIdTag.id = qualtricsSnippetId;
    snippetIdTag.innerHTML = '<!--DO NOT REMOVE-CONTENTS PLACED HERE-->';

    const head = document.getElementsByTagName('head')[0];
    head.appendChild(scriptTag);
    head.appendChild(snippetScriptTag);
    head.appendChild(snippetIdTag);
  }
};

export const updateQualtricsData = (data: Record<string, unknown>, key: keyof QualtricsData) => {
  const qualtricsStored: QualtricsData = parseLocalStorage(QUALTRICS_KEY_LOCALSTORAGE) || {};

  const updatedData: QualtricsData = {
    ...qualtricsStored,
    [key]: {
      ...(qualtricsStored[key] || {}),
      ...data,
    },
  };
  localStorage.setItem(QUALTRICS_KEY_LOCALSTORAGE, JSON.stringify(updatedData));
};

const setGeneralSurvey = () => {
  const parsed = parseLocalStorage(QUALTRICS_KEY_LOCALSTORAGE);
  const uniqueDaysCount = (parsed?.generalSurvey?.uniqueDaysCount || 0) + 1;
  updateQualtricsData({ uniqueDaysCount }, QUALTRICS_KEY_GENERAL_SURVEY);
};

const clearQualtricsData = () => {
  localStorage.removeItem(QUALTRICS_KEY_LOCALSTORAGE);
};

export const setQualtricsUserData = (
  hudlUserId: string,
  email: string,
  firstName: string,
  lastName: string,
  entityId: string,
  entityName: string,
): void => {
  const today = new Date().toISOString().split('T')[0];
  const qualtricsStored: QualtricsData = parseLocalStorage(QUALTRICS_KEY_LOCALSTORAGE);
  const isNewDay = qualtricsStored?.metadata?.lastActiveDate !== today;

  if (!qualtricsStored?.metadata) {
    clearQualtricsData();
    updateQualtricsData(
      {
        hudlUserId,
        email,
        firstName,
        lastName,
        entityName,
        entityId,
        lastActiveDate: today,
      },
      QUALTRICS_KEY_METADATA,
    );
  }

  if (isNewDay) {
    setGeneralSurvey();
    updateQualtricsData({ lastActiveDate: today }, QUALTRICS_KEY_METADATA);
  }
};
